var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBigGreenTickIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5 26.625C15.2236 26.625 16.9303 26.2855 18.5227 25.6259C20.1151 24.9663 21.562 23.9995 22.7808 22.7808C23.9995 21.562 24.9663 20.1151 25.6259 18.5227C26.2855 16.9303 26.625 15.2236 26.625 13.5C26.625 11.7764 26.2855 10.0697 25.6259 8.47728C24.9663 6.88488 23.9995 5.43799 22.7808 4.21922C21.562 3.00045 20.1151 2.03367 18.5227 1.37408C16.9303 0.714488 15.2236 0.375 13.5 0.375C10.019 0.375 6.68064 1.75781 4.21922 4.21922C1.75781 6.68064 0.375 10.019 0.375 13.5C0.375 16.981 1.75781 20.3194 4.21922 22.7808C6.68064 25.2422 10.019 26.625 13.5 26.625ZM13.1617 18.8083L20.4533 10.0583L18.2133 8.19167L11.9425 15.7152L8.69771 12.469L6.63563 14.531L11.0106 18.906L12.1394 20.0348L13.1617 18.8083Z",
    fill: "#11B837"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBigGreenTickIcon);
export default __webpack_public_path__ + "static/media/BigGreenTickIcon.93c563a87a8c6c283e1a80e81f8ce812.svg";
export { ForwardRef as ReactComponent };